import React from "react";
import { motion } from "framer-motion";

export default function Intestazione(props) {
    const isHome = props.isHome?props.isHome:false;

    if (isHome) {
    return (
      <header
        className="hero-container home"
        role="banner"
        aria-label="Sezione introduttiva: Gestione Sportiva"
      >
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          {/* Header con logo, nome prodotto e slogan */}
          <div className="hero-header">
            <motion.div
              className="hero-header-left"
              initial={{ opacity: 0, x: -40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
            >
              <img
                src={require("./immagini/logotrasparente.png")}
                alt="Logo GS Gestione Sportiva"
                className="hero-logo"
                loading="lazy"
              />
              <h1 className="nome-prodotto">
                <span className="blu">Gestione</span>{" "}
                <span className="verde">Sportiva</span>
              </h1>
            </motion.div>

            <motion.div
              className="hero-header-right"
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
            >
              <p className="slogan" aria-label="Slogan">
                la tua società sportiva in un clic
              </p>
            </motion.div>
          </div>

          {/* Immagine dispositivi */}
          <motion.div
            className="hero-dispositivi"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.6 }}
          >
            <img
              src={require("./immagini/dispositivitrasparente.png")}
              alt="Gestione Sportiva su PC e smartphone"
              className="immagine-dispositivi-piccola"
              loading="lazy"
            />
          </motion.div>
        </motion.div>
      </header>
    );
  } else {
    return (
        <header
        className="hero-container altro"
        role="banner"
        aria-label="Intestazione pagina: Gestione Sportiva"
        >
            <div className="hero-header">
                <div className="hero-header-left">
                    <img
                        src={require("./immagini/logotrasparente.png")}
                        alt="Logo GS Gestione Sportiva"
                        className="hero-logo"
                        loading="lazy"
                    />
                    <h1 className="nome-prodotto">
                        <span className="blu">Gestione</span>{" "}
                        <span className="verde">Sportiva</span>
                    </h1>
                </div>

                {props.titoloPagina && (
                <div className="hero-header-right">
                    <h2 className="titolo-pagina">{props.titoloPagina}</h2>
                </div>
                )}
            </div>
        </header>
    );
  }
}